<template>
	<div class="flex flex-col bg-slate-100">
		<div class="sticky flex items-center px-5 py-4 bg-white shadow-sm top-safe">
			<Icon
				name="mdi:arrow-right"
				class="w-9 h-9 p-1.5 rounded-full -ms-1.5 text-primary bg-primary bg-opacity-0 hover:bg-opacity-10 duration-300 cursor-pointer transform ltr:-scale-x-100"
				@click="$backWithFallback($routeUrl.HomeUrl())"
			/>
			<div class="flex-grow" />
			<NuxtLink :to="$routeUrl.HomeUrl()">
				<img src="/img/main_logo.png" alt="" class="w-auto h-8" />
			</NuxtLink>
		</div>
		<div class="flex flex-col items-center flex-grow px-6 pt-16 pb-16">
			<main class="flex flex-col w-full max-w-screen-lg prose-sm prose md:prose-lg lg:prose-xl prose-slate">
				<h1>Terms of Service</h1>

				<p>
					These Terms of Service ("Terms") govern your access to and use of the Jiran mobile application and
					website (collectively referred to as the "Service"). Please read these Terms carefully before using
					the Service.
				</p>

				<h2>1. Acceptance of Terms</h2>
				<p>
					By using the Service, you agree to be bound by these Terms. If you do not agree to these Terms,
					please do not use the Service.
				</p>

				<h2>2. Age Requirement</h2>

				<p>You must be at least 13 years of age or have parental consent to use the Service.</p>

				<h2>3. User Content</h2>
				<p>
					The Service allows users to post, upload, or submit content ("User Content"). You are solely
					responsible for your User Content and the consequences of sharing or publishing it.
				</p>

				<div>
					<p>Content Standards: You agree not to submit User Content that is:</p>
					<ul>
						<li>Illegal, harassing, defamatory, obscene, hateful, or threatening.</li>
						<li>Infringes on the intellectual property rights of others.</li>
						<li>Violates the privacy of others.</li>
						<li>Spams or promotes commercial products or services without our permission.</li>
						<li>Deceives or misleads others.</li>
					</ul>
				</div>

				<h2>4. Promoting Local Businesses and Selling</h2>

				<p>
					Jiran encourages users to connect and support their local communities. Here's how you can promote
					your business or sell items responsibly:
				</p>

				<ul>
					<li>
						Dedicated Features: Utilize designated features like business listings or selling sections
						within Jiran. These features provide a structured platform for promoting products and services.
					</li>
					<li>
						Focus on Community: Frame your posts or listings within the context of helping your neighbors.
						Highlight how your offerings benefit the local community.
					</li>
					<li>Avoid Spam: Don't engage in excessive posting, irrelevant promotions, or misleading claims.</li>
				</ul>

				<p>
					Jiran's Rights: We reserve the right to remove or edit any User Content that violates these Terms or
					that we deem inappropriate for any reason. We may also suspend or terminate your access to the
					Service for violating these Terms.
				</p>

				<h2>4. Reporting and Moderation</h2>

				<ul>
					<li>
						Reporting: We encourage users to report any User Content that they believe violates these Terms.
						You can report content by [insert reporting method, e.g., flagging the content or contacting
						us].
					</li>
					<li>
						Moderation: We take user safety seriously and have a dedicated team to review reported content.
						We will take appropriate action, which may include removing the content, issuing warnings, or
						banning users, based on the severity of the violation.
					</li>
				</ul>

				<h2>5. Privacy</h2>
				<p>
					Our privacy practices are described in our
					<NuxtLink :to="$routeUrl.PrivacyPolicyUrl()">Privacy Policy</NuxtLink>. By using the Service, you
					consent to our collection and use of your personal information as set out in the Privacy Policy.
				</p>

				<h2>6. Termination</h2>
				<p>
					We may terminate or suspend your access to the Service immediately, without prior notice or
					liability, for any reason, including if you breach these Terms.
				</p>

				<h2>7. Changes to Terms</h2>
				<p>
					We reserve the right to modify or replace these Terms at any time. Changes will be effective when
					posted. Your continued use of the Service after changes are posted constitutes your acceptance of
					those changes.
				</p>

				<h2>8. Contact Information</h2>
				<p>If you have any questions about these Terms, please contact us at dev.jiran@gmail.com</p>
			</main>
		</div>
	</div>
</template>
